var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9523 22.1104L20.0558 18.2139C19.5666 18.9398 18.9406 19.5661 18.2144 20.0553L22.1108 23.9518C22.6193 24.4603 23.4438 24.4603 23.9523 23.9518C24.4601 23.445 24.4601 22.6182 23.9523 22.1104Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66675 14.4378C7.66675 10.6986 10.698 7.66699 14.4083 7.66699C18.1778 7.66699 21.1791 10.6986 21.1791 14.4378C21.1791 18.1771 18.1186 21.2087 14.4083 21.2087C10.698 21.2087 7.66675 18.1771 7.66675 14.4378ZM10.2418 14.4378C10.2418 16.7353 12.1109 18.6045 14.4084 18.6045C16.7359 18.6045 18.5751 16.736 18.5751 14.4378C18.5751 12.1403 16.7059 10.2712 14.4084 10.2712C12.1109 10.2712 10.2418 12.1403 10.2418 14.4378Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSearch);
export default __webpack_public_path__ + "static/media/navbar-search.53a39b7c187a622353eb5248b43d8bae.svg";
export { ForwardRef as ReactComponent };